<template>
    <div class="container">
        <div class="title-group">
            <img class="title-icon" src="@/assets/basic/logo.png"></img>
            <div class="title-text">{{projectName}}</div>
        </div>
        <div class="menu-content">
            <a-menu :selected-keys="[$route.path]" mode="inline" theme="dark" :inline-collapsed="menuCollapse" :style="{width: menuCollapse ? '80px' : '240px', flex: 1}">
                <template v-for="(item) in getRoutesPermitted">
                    <a-menu-item @click="$util.common.toRoute($route, $router, item.path)" v-if="!item.children && item.meta.title"
                        :key="item.path">
                        <a-icon :type="item.meta.icon" />
                        <span>{{item.meta.title}}</span>
                    </a-menu-item>
                    <a-sub-menu v-if="item.children" :key="item.path">
                        <span slot="title">
                            <a-icon :type="item.meta.icon" />
                            <span>{{item.meta.title}}</span>
                        </span>
                        <a-menu-item v-for="(item2) in item.children" :key="`${item.path}/${item2.path}`" @click="$util.common.toRoute($route, $router, `${item.path}/${item2.path}`)">
                            <a-icon :type="item2.meta.icon" />
                            <span>{{item2.meta.title}}</span>
                        </a-menu-item>
                    </a-sub-menu>
                </template>
            </a-menu>
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex'
import {
    stationMap
} from '@/common/project-config'

export default {
    computed: {
        ...mapState('global', ['menuPermitted', 'menuCollapse']),
        ...mapState('stored', {
            projectName: (state) => stationMap[state.userInfo.stationId]
        }),
        ...mapGetters('global', ['getRoutesPermitted'])
    },
    components: {},
    props: {},
    created() {
        document.title = this.projectName
    },
    methods: {

    }
}
</script>

<style scoped lang="less">
    .container {
        height: 100%;
        user-select: none;
        display: flex;
        flex-direction: column;

        .menu-content {
            overflow: scroll;
            flex: 1;
            display: flex;
            flex-direction: column;

            &::-webkit-scrollbar {
                display: none !important;
            }
        }

        .title-group {
            position: relative;
            font-size: 20px;
            color: white;
            background-color: #001529;
            display: flex;
            align-items: center;
            overflow: hidden;

            @icon-size: 50;

            .title-icon {
                width: unit(@icon-size, px);
                height: unit(@icon-size, px);
                margin: 14px;
            }

            .title-text {
                position: absolute;
                left: unit(@icon-size + 30, px);
                white-space: pre;
            }
        }
    }
</style>
